var _rect, _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 2.5,
    stroke: "#8292AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5C5.02754 11.5 2.37728 10.1367 0.634846 8C2.37728 5.86327 5.02754 4.5 8 4.5C10.9725 4.5 13.6227 5.86327 15.3652 8C13.6227 10.1367 10.9725 11.5 8 11.5Z",
    stroke: "#8292AB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCView);
export default __webpack_public_path__ + "static/media/icon_c_view.e0d679c7e4d657fd88b14d8c9af1dc59.svg";
export { ForwardRef as ReactComponent };